import { writable, get } from "svelte/store";
import { TopicService } from "../services/TopicService";
import { ClusterType } from "./ClusterStore";
const store = () => {
    // create store
    const { subscribe, set, update } = writable(null);
    const RECENT_TOPICS_COUNT = 4;
    return {
        subscribe,
        set,
        update,
        load: async () => {
            // clear store
            set(null);
            // pull new data
            let topics = await TopicService.getRecentTopics();
            set(topics);
            return topics;
        },
        refresh: () => {
            TopicService.getRecentTopics().then((topics) => {
                set(topics);
            });
        },
        addMostRecent: (topic) => {
            update((topics) => {
                const existing = topics.find((t) => t.id === topic.id);
                if (existing) {
                    topics = topics.filter((t) => t.id !== topic.id);
                    topics.unshift(topic);
                }
                else {
                    topics.unshift(topic);
                    topics.pop();
                }
                return topics;
            });
        },
        populateTopicsFromClusters: (clusters) => {
            const userClusters = clusters.filter((cluster) => cluster.clusterType !== ClusterType.SHARED_WITH_ME &&
                cluster.clusterType !== ClusterType.SHARED);
            update((topics) => {
                if (!topics.length) {
                    return userClusters
                        .reduce((acc, cluster) => [...acc, ...cluster.topics], [])
                        .sort((a, b) => b.createdOn - a.createdOn)
                        .slice(0, RECENT_TOPICS_COUNT);
                }
                else if (topics.length < RECENT_TOPICS_COUNT) {
                    const newTopics = userClusters
                        .reduce((acc, cluster) => [
                        ...acc,
                        ...cluster.topics.filter((t) => !topics
                            .map((el) => el.id)
                            .includes(t.id)),
                    ], [])
                        .sort((a, b) => b.createdOn - a.createdOn)
                        .slice(0, RECENT_TOPICS_COUNT - topics.length);
                    return [...topics, ...newTopics];
                }
                return topics;
            });
        },
        updateTopic: (topic) => {
            update((topics) => topics &&
                topics.map((t) => (t.id === topic.id ? topic : t)));
        },
        updateTopicsUser: (user) => {
            update((topics) => topics.map((topic) => topic.createdBy.id === user.id
                ? Object.assign(Object.assign({}, topic), { createdBy: Object.assign(Object.assign({}, topic.createdBy), { firstName: user.firstName, lastName: user.lastName }) }) : topic));
        },
        deleteTopic: (topicId) => {
            update((topics) => topics === null || topics === void 0 ? void 0 : topics.filter((t) => t.id !== topicId));
        },
    };
};
export const RecentTopicsStore = store();
